// extracted by mini-css-extract-plugin
export var container = "TabModule-module--container--3c398";
export var headline = "TabModule-module--headline--42362";
export var image = "TabModule-module--image--7c449";
export var tabWrapper = "TabModule-module--tabWrapper--e752f";